import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const JwtPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');

    if (accessToken) {
      Cookies.set('accessToken', accessToken, { path: '/', secure: true });
    }
    if (refreshToken) {
      Cookies.set('refreshToken', refreshToken, { path: '/', secure: true });
    }
    navigate('/dashboard');
  }, [searchParams, navigate]);

  return <div>Redirecting to dashboard...</div>;
};

export default JwtPage;
